import React from 'react'
import styled from 'styled-components'

import { formatAddress } from 'utils/address'

const Container = styled.div`
  text-transform: uppercase;
`

export default function Address({
  city,
  state,
  zipcode,
}: {
  city: string
  state: string
  zipcode: string
}) {
  return <Container>{formatAddress(city, state, zipcode)}</Container>
}
